export default __webpack_public_path__ + "static/media/odlo.1df3f331.svg";